import { PUBLISHED_STRUCTURED_CONTENT_FIELDS } from '../../fragments/message/published-structured-content-fields';
import { gql } from 'apollo-boost';
import { READ_ONLY_URL_META_FIELDS } from '../../fragments/message/read-only-url-meta-fields';

export const GET_SHARED_MESSAGE = gql`
    query getSharedMessage($messageId: ID!) {
        getSharedMessage(messageId: $messageId) {
            id
            title
            body
            createdAt
            artifactBadges { type count }
            entities { type name confidence }
            image {
                public_id
                shared_asset_id
                size
                mime
                duration
                aspect_ratio
                url
                cdn_url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                }
                name
                displayName
                type
                format
                width
                height
            }
            file {
                public_id
                shared_asset_id
                width
                height
                duration
                aspect_ratio
                thumbnail { sm md lg xl original }
                url
                cdn_url
                name
                displayName
                type
                format
                size
                mime
            }
            ${READ_ONLY_URL_META_FIELDS}
            caption
            keywords
            ocrText
            transcript { text source status sourceUrl urlMetaIndex segments { start end text } }
            transcriptionSegments { start end text }
            ${PUBLISHED_STRUCTURED_CONTENT_FIELDS}
            type {
                type
            }
            sourceHost
            sourceUrls
            canonicalSourceUrls
        }
    }
`;

export const GET_MESSAGE_SHARES = gql`
    query getMessageShares($messageId: ID!) {
        getMessageShareUrl(messageId: $messageId)
        getMessageShares(messageId: $messageId) {
            subjectUser {
                id
                email
                fullName
            }
            role
            includeSubfolders
            sharedAt
            lastAccessedAt
            accessCount
        }
    }
`;
export const GET_MESSAGE_PUBLISH_STATUS = gql`
    query getMessagePublishStatus($messageId: ID!) {
        getMessagePublishStatus(messageId: $messageId) {
            token
            url
            discoverable
            allowCopy
            linkRole
            allowAnonymousContributions
            viewCount
            createdAt
        }
    }
`;
export const GET_SHARED_MESSAGES = gql`
    query getSharedMessages($cursor: ID) {
        getSharedMessages(cursor: $cursor) {
            items {
                message {
                    id
                    title
                    createdAt
                }
                owner {
                    id
                    email
                    fullName
                }
                sharedAt
            }
            cursor
        }
    }
`;

export const GET_MESSAGE_SHARING_STATUS = gql`
    query getMessageSharingStatus($messageId: ID!) {
        getMessageSharingStatus(messageId: $messageId) { id shareCount isPublished }
    }
`;
export const GET_OWNED_SHARED_MESSAGES = gql`
    query getOwnedSharedMessages($cursor: ID) {
        getOwnedSharedMessages(cursor: $cursor) {
            items {
                message { id title bodyPreview createdAt }
                sharingStatus { id shareCount isPublished }
            }
            cursor
        }
    }
`;
